<script setup lang="ts">
import modernStatusChip from "@/components/reusable/modernStatusChip.vue"
import starDisplay from "@/components/reusable/starDisplay.vue"

const props = defineProps(["potential", "buttonText", "buttonClick"])
</script>

<template>
    <div class="crm-potential-card w-full">
        <div class="labels-list flex gap-4 max-w-[95%] overflow-x-scroll">
            <modern-status-chip 
                class="!text-left !justify-start mb-8" 
                v-for="category in potential.potentialCategories" 
                :key="category.id"
                :text="category.name"
                :bgColors="{ [category.id]: category.color }"
                :value="category.id"
            />
        </div>
        <header class="flex items-center justify-between">
            <h3 class="mb-0 text-3xl">{{ props.potential.title }}</h3>
            <star-display :picked-quantity="potential.potentialRating" />
        </header>
      
        <p>{{ potential.description }}</p>
        <hr>
        <ul class="potential-assignees">
            <li v-for="assignedTo in potential.assignedTo" :key="assignedTo.id">
                <img referrerpolicy="no-referrer" v-if="assignedTo.profileImage && assignedTo.profileImage !== ''" :src="assignedTo.profileImage" alt="Profile Image" class="w-10 h-10 rounded-full" />
                <div v-else class="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
                    <p>{{ assignedTo.userName.charAt(0) }}</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>

@import "../../styles/core/variables.scss";


.crm-potential-card{
    background-color: $color-box-background;
    border: 1px solid $border-color;
    border-radius: 10px;
    padding: 2.4rem 2.4rem;
    cursor: pointer;
}

.crm-potential-card:hover{
    background-color: $color-box-background-hover;
}



.labels-list{
    overflow-x: scroll;
    max-width: 95%;
}

hr{
    margin: 1.6rem auto 1.6rem 0;
    border: 1px solid $border-color;
    opacity: 0.5;
}

p{
    font-size: 1.2rem;
    margin: 2.4rem 0;
    /* Display a maximum of 2 lines */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    max-width: 100%;
    line-height: 1.4;
}

.potential-assignees {
    display: flex;
    align-items: center;
}

.potential-assignees li:not(:first-child){
    margin-left: -1rem;
}
</style>